import { defineMessages } from '@sm/intl';

const FORMS = 'Forms - GROW-2529';
const PRICING_DESCRIPTION = '[Type: String][Vis.: high] - A string in pricing experiment GROW-2529';

const billingToggleCopy = defineMessages({
  grow_2529_annual_billing: {
    id: 'Pricing.billingToggleCopy.Annual',
    defaultMessage: 'Annual {percentage}',
    desc: {
      id: 'Pricing.billingToggleCopy.Annual',
      message: PRICING_DESCRIPTION,
      project: FORMS,
    },
  },
  grow_2529_monthly_billing: {
    id: 'Pricing.billingToggleCopy.Monthly',
    defaultMessage: 'Monthly',
    desc: {
      id: 'Pricing.billingToggleCopy.Monthly',
      message: PRICING_DESCRIPTION,
      project: FORMS,
    },
  },
});

export default billingToggleCopy;
